export const getBackground = () => "var(--ds-surface, #FFFFFF)";